var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout, Radio, RadioGroup, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
var SingleChoice = function (_a) {
    var options = _a.options, selected = _a.selected;
    return (_jsx(Layout, { children: _jsx(RadioGroup, __assign({ row: false, value: selected === null || selected === void 0 ? void 0 : selected[0], color: "primary", sx: {
                '& .MuiFormControlLabel-label': {
                    width: '100%',
                },
            } }, { children: options.map(function (v, i) {
                return (_jsx(Radio
                // @ts-ignore
                , { 
                    // @ts-ignore
                    FormControlLabelProps: {
                        sx: { pointerEvents: 'none' },
                    }, value: i, label: _jsxs(Stack, __assign({ color: "".concat(i === selected[0] ? '#4caf50' : 'rgba(0,0,0,.56)'), fontWeight: "".concat(i === selected[0] ? 'medium' : 'normal'), width: "100%", direction: "row", spacing: 1, alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ color: "inherit", fontWeight: "inherit", variant: "caption", flexWrap: "wrap", sx: { wordBreak: 'break-all' } }, { children: v.content })), _jsxs(Typography, __assign({ color: "inherit", fontWeight: "inherit", variant: "caption", flexShrink: 0 }, { children: [v.score, "\u5206"] }))] })) }, i));
            }) })) }));
};
export default SingleChoice;
